/**
 * Composable for resolving localized script variables across admin and client contexts.
 *
 * Admin context provides: adminresturl, entityresturl, adminrestnonce, templatedir, homeurl
 * Client context provides: resturl, entityresturl, restnonce, templatedir, homeurl, ajaxurl, siteurl, slug
 */
export function useLocalized() {
    const isAdmin = !!localized.adminrestnonce;

    return {
        isAdmin,
        entityRestUrl: localized.entityresturl,
        restUrl: isAdmin ? localized.adminresturl : localized.resturl,
        restNonce: isAdmin ? localized.adminrestnonce : localized.restnonce,
        templateDir: localized.templatedir,
        homeUrl: localized.homeurl
    };
}
